export default __webpack_public_path__ + "static/media/Celsius.ecd1e7bc.svg";